<template>
    <div class="element-toast-notifications">
        <toast-notification
            v-for="toast in toasts"
            :key="toast.id"
            v-bind="toast"
            @close="onClose"
        />
    </div>
</template>

<script>
import _ from 'lodash'
import ToastNotification from './ToastNotification.vue'
import Echo from '../helpers/echo'
import EventBus from '../helpers/event-bus'

export default {
    components: { ToastNotification },
    props: {
        channels: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            toasts: []
        }
    },
    computed: { },
    methods: {
        onClose (id) {
            const index = _.findIndex(this.toasts, { id })
            if (index >= 0) {
                this.toasts.splice(index, 1)
            }
        },
        addToast (toast) {
            this.toasts.push(toast)

            if (this.toasts.length > 5) {
                this.toasts.shift()
            }
        }
    },
    created () {
        // console.log(this.channels)
        // console.log(Echo)

        this.channels.forEach((params) => {
            // get private channel
            const channel = Echo.private(params.id)

            // subscribe to notifications
            if (params.notifications) {
                channel.notification((notification) => {
                    // console.log(notification)
                    this.addToast(notification)
                })
            }

            // listen for events
            _.each(params.events, (name) => {
                channel.listen(name, (e) => {
                    // console.log(e)
                    this.addToast(e.toast)
                })
            })
        })

        EventBus.$on('toast:notification', this.addToast)
    }
}
</script>
